import React, { useState, useEffect } from 'react';
import { Modal, Input, Form } from 'antd';

const { TextArea } = Input;

export interface AdminNoteModalProps {
  open: boolean;
  title?: string;
  okText?: string;
  onConfirm: (adminNote: string) => void | Promise<void>;
  onCancel: () => void;
  loading?: boolean;
}

export const AdminNoteModal: React.FC<AdminNoteModalProps> = ({
  open,
  title = 'Confirm changes',
  okText = 'Save',
  onConfirm,
  onCancel,
  loading = false,
}) => {
  const [form] = Form.useForm();
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);

  const handleOk = async () => {
    try {
      const values = await form.validateFields();
      const note = (values.adminNote ?? '').trim();
      if (!note) {
        form.setFields([
          { name: 'adminNote', errors: ['Admin note is required'] },
        ]);
        return;
      }
      setSubmitting(true);
      await onConfirm(note);
      form.resetFields();
      onCancel();
    } catch {
      // Validation failed
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      title={title}
      open={open}
      onOk={handleOk}
      onCancel={onCancel}
      confirmLoading={loading || submitting}
      okText={okText}
      destroyOnClose
      maskClosable={false}
    >
      <Form form={form} layout="vertical" style={{ marginTop: 16 }}>
        <Form.Item
          name="adminNote"
          label="Ghi chú quản trị viên (bắt buộc)"
          rules={[
            { required: true, message: 'Please enter an admin note for audit' },
            { min: 3, message: 'Note must be at least 3 characters' },
          ]}
        >
          <TextArea
            rows={3}
            placeholder="e.g. Price update per merchant request"
            maxLength={500}
            showCount
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
